let React = require('react');

let TipoTarjetaItem = React.createClass({
    render: function () {
        return (
            <option value={this.props.kind.Id}>{this.props.kind.Descripcion}</option>
        );
    }
});

export default TipoTarjetaItem